import { ExportsPanel } from '@/features/exports/ui/ExportsPanel';

/**
 * §5: a page composes, it does not implement.
 */
export function ExportsPage() {
  return <ExportsPanel />;
}
